import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, useField } from 'react-final-form-hooks';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { useTheme } from '../../ThemeContext';

import {
  forgotPassword,
  forgotPasswordInit,
} from '../../actions/Auth/AuthActions';

import IMAGE_LOGO from '../../assets/Images/Logo.svg';
import IMAGE_CHECK from '../../assets/Images/Check.svg';

import {
  Panel,
  Logobox,
  Logo,
  Textbox,
  Text,
  Strong,
  Form,
  Inputbox,
  Input,
  InputError,
  SubmitButton,
  Linkbox,
  Successbox,
  SuccessImage,
} from './ForgotPasswordPanel.style';

const ForgotPasswordPanel = () => {
  const intl = useIntl();
  const theme = useTheme();
  const history = useHistory();
  const authForgotPasswordStore = useSelector(
    (state) => state.authForgotPasswordStore
  );
  const { isLoading, isSuccess, isError, error } = authForgotPasswordStore;
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    dispatch(
      forgotPassword({
        email: values.email,
      })
    ).then((res) => {
      if (res) history.push('/');
    });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.email)
      errors.email = intl.formatMessage({
        id: 'FORM.VALIDATION.THIS_FIELD_IS_REQUIRED',
      });
    if (
      values.email &&
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        values.email
      )
    )
      errors.email = intl.formatMessage({
        id: 'FORM.VALIDATION.INVALID_EMAIL_ADDRESS',
      });
    return errors;
  };

  const { form, handleSubmit, pristine, submitting, invalid } = useForm({
    onSubmit,
    validate,
  });
  const emailField = useField('email', form);

  useEffect(() => {
    dispatch(forgotPasswordInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Panel>
      <Logobox>
        <Logo src={IMAGE_LOGO} />
      </Logobox>

      <Textbox>
        {isError ? (
          <Text theme={theme.sign.text.error}>
            {intl.formatMessage({
              id: `FORGOT_PASSWORD_PANEL.ERROR.${error}`,
              defaultMessage: error,
            })}
          </Text>
        ) : isSuccess ? (
          <>
            <Text theme={theme.sign.text.default}>
              <Strong>
                {intl.formatMessage({
                  id: `FORGOT_PASSWORD_PANEL.SUCCESS`,
                })}
              </Strong>
            </Text>
            <Successbox>
              <SuccessImage
                src={IMAGE_CHECK}
                alt={intl.formatMessage({
                  id: `FORGOT_PASSWORD_PANEL.SUCCESS`,
                })}
              />
            </Successbox>
          </>
        ) : (
          <Text theme={theme.sign.text.default}>
            <Strong>
              {intl.formatMessage({
                id: 'FORGOT_PASSWORD_PANEL.INFO.FORGOT_YOUR_PASSWORD',
              })}
              ?
            </Strong>
            <Text theme={theme.sign.text.default}>
              {intl.formatMessage({
                id:
                  'FORGOT_PASSWORD_PANEL.INFO.ENTER_YOUR_E-MAIL_ADDRESS_AND_YOU_WILL_RECEIVE_RESET_LINK',
              })}
              .
            </Text>
          </Text>
        )}
      </Textbox>

      {!isSuccess ? (
        <Form onSubmit={handleSubmit}>
          <Inputbox>
            <Input
              theme={theme.input.default}
              {...emailField.input}
              type='email'
              placeholder={intl.formatMessage({
                id: 'FORGOT_PASSWORD_PANEL.INPUT.EMAIL_ADDRESS',
              })}
              autoComplete='on'
              invalid={emailField.meta.touched && emailField.meta.error}
              valid={
                emailField.input.value &&
                !(emailField.meta.touched && emailField.meta.error)
              }
            />
            <InputError theme={theme.inputError.default}>
              {emailField.meta.touched && emailField.meta.error}
            </InputError>
          </Inputbox>

          <SubmitButton
            theme={theme.button.default}
            disabled={submitting || pristine || invalid || isLoading}
          >
            {isLoading
              ? intl.formatMessage({
                  id: 'FORGOT_PASSWORD_PANEL.SUBMIT_BUTTON.PLEASE_WAIT',
                })
              : intl.formatMessage({
                  id: 'FORGOT_PASSWORD_PANEL.SUBMIT_BUTTON.SEND_RESET_LINK',
                })}
          </SubmitButton>

          <Linkbox theme={theme.sign.linkbox}>
            <Link to={`/`}>
              {intl.formatMessage({
                id: 'FORGOT_PASSWORD_PANEL.BUTTON.BACK_TO_SIGN_IN',
              })}
              .
            </Link>
          </Linkbox>
        </Form>
      ) : (
        <Linkbox theme={theme.sign.linkbox}>
          <Link to={`/`}>
            {intl.formatMessage({
              id: 'FORGOT_PASSWORD_PANEL.BUTTON.BACK_TO_SIGN_IN',
            })}
            .
          </Link>
        </Linkbox>
      )}
    </Panel>
  );
};

ForgotPasswordPanel.propTypes = {};

export default ForgotPasswordPanel;
